import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/sys/agent/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 获取列表
export function getConsignerPage(data) {
  return request.send({
    url: `/pmy/sys/sys/agent/consigner/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 添加
export function addInfo(data) {
  return request.send({
    url: `/pmy/sys/sys/agent`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 添加发货人
export function addConsignerInfo(data) {
  return request.send({
    url: `/pmy/sys/sys/agent/consigner`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 编辑
export function editInfo(data) {
  return request.send({
    url: `/pmy/sys/sys/agent`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 编辑发货人
export function editConsignerInfo(data) {
  return request.send({
    url: `/pmy/sys/sys/agent/consigner`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 删除
export function deleteInfo(agentId) {
  return request.send({
    url: `/pmy/sys/sys/agent?companyId=${agentId}`,
    method: "delete"
  });
}
// 删除发货人
export function deleteConsignerInfo(userId) {
  return request.send({
    url: `/pmy/sys/sys/agent/consigner?userId=${userId}`,
    method: "delete"
  });
}
// 重置密码
export function resetPassword(data) {
  return request.send({
    url: `/pmy/sys/sys/agent/consigner/reset-pwd`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 详情
export function detailInfo(agentId) {
  return request.send({
    url: `/pmy/sys/sys/agent?companyId=${agentId}`,
    method: "get"
  });
}

// 公司基础信息列表（用于下拉选择）
// export function getSelectAgent() {
//   return request.send({
//     url: `/pmy/sys/sys/agent/base/all`,
//     method: "get"
//   });
// }

// 代理商（用于下拉选择）
export function getSelectAgent(params) {
  return request.send({
    url: `/pmy/sys/sys/agent/base/list?belongCompanyId=${params.belongCompanyId}&keyword=${params.keyword}`,
    method: "get"
  });
}

// 发货人（用于下拉选择）
export function getSelectConsigner(params) {
  return request.send({
    url: `/pmy/sys/sys/agent/consigner/list?companyId=${params.companyId}`,
    method: "get"
  });
}
